module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "dedication",
    attrs: {
      "id": "ded"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("To my own godchildren")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("—Helena Allan, Edie Campbell, Cara Delevingne,"), _c('br'), _vm._v("Ned Dahl Donovan, lone Hunter Gordon,"), _c('br'), _vm._v("Willa Montagu Petty and Ewan Wotherspoon–")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("who luckily in no way resemble"), _c('br'), _vm._v("the godchildren in this story.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-011c6061","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780312382582_epub_ded_r1.vue
// module id = 66
// module chunks = 0